import {
  Target,
  Eye,
  ScrollText,
  ShieldCheck,
  Handshake,
  Gem,
  Heart,
  Zap,
  Cross,
} from "lucide-react";

const VALORES = [
  { icon: ShieldCheck, label: "Respeito" },
  { icon: Handshake, label: "Solidariedade" },
  { icon: Gem, label: "Transparência" },
  { icon: ScrollText, label: "Honestidade" },
  { icon: Heart, label: "Empatia" },
  { icon: Zap, label: "Perseverança" },
  { icon: Cross, label: "Valores cristãos" },
];

export default function MissaoVisaoValores() {
  return (
    <section
      id="missao-visao-valores"
      data-testid="missao-visao-valores-section"
      className="section-pad bg-background"
    >
      <div className="container-ga">
        <div className="max-w-2xl mb-12">
          <div className="pill border-ga-ink/10 text-ga-ink/70 bg-ga-ink/5 mb-5" data-testid="mvv-pill">
            <Target className="w-3.5 h-3.5" />
            Missão, visão e valores
          </div>
          <h2 className="font-display font-black tracking-tighter text-3xl sm:text-4xl lg:text-5xl leading-[1.05] text-ga-ink">
            O que nos <span className="gradient-text-ga">guia</span> todos os dias.
          </h2>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-5">
          <article
            data-testid="mvv-missao"
            className="rounded-[2rem] bg-ga-ink text-white p-8 relative overflow-hidden"
          >
            <div className="absolute -top-10 -right-10 w-52 h-52 rounded-full bg-ga-emerald/30 blur-3xl" />
            <Target className="w-8 h-8 text-ga-emerald relative" />
            <h3 className="font-display font-bold text-2xl mt-5 relative">Missão</h3>
            <p className="mt-3 text-white/80 leading-relaxed text-[15px] relative">
              Transformar vidas através do esporte, ações sociais e terapias,
              promovendo inclusão e desenvolvimento integral, preservando
              valores cristãos e familiares.
            </p>
          </article>

          <article
            data-testid="mvv-visao"
            className="rounded-[2rem] bg-white border-2 border-ga-amber/30 p-8 relative overflow-hidden"
          >
            <div className="absolute -top-10 -right-10 w-52 h-52 rounded-full bg-ga-amber/20 blur-3xl" />
            <Eye className="w-8 h-8 text-ga-amber_deep relative" />
            <h3 className="font-display font-bold text-2xl mt-5 text-ga-ink relative">Visão</h3>
            <p className="mt-3 text-ga-ink/75 leading-relaxed text-[15px] relative">
              Ser reconhecido como referência em atendimento social e
              neurodiversidade em Jaboatão dos Guararapes e região.
            </p>
          </article>

          <article
            data-testid="mvv-valores"
            className="rounded-[2rem] bg-white border border-border p-8"
          >
            <ScrollText className="w-8 h-8 text-ga-emerald_deep" />
            <h3 className="font-display font-bold text-2xl mt-5 text-ga-ink">Valores</h3>
            <ul className="mt-5 grid grid-cols-1 gap-2.5">
              {VALORES.map((v, i) => (
                <li
                  key={v.label}
                  data-testid={`valor-${i}`}
                  className="flex items-center gap-3 text-sm text-ga-ink"
                >
                  <span className="inline-flex items-center justify-center w-7 h-7 rounded-lg bg-ga-emerald/10 text-ga-emerald_deep">
                    <v.icon className="w-3.5 h-3.5" />
                  </span>
                  <span className="font-semibold">{v.label}</span>
                </li>
              ))}
            </ul>
          </article>
        </div>
      </div>
    </section>
  );
}
